import { render, staticRenderFns } from "./LinkAccion.vue?vue&type=template&id=e8fd83c0&scoped=true&"
import script from "./LinkAccion.vue?vue&type=script&lang=js&"
export * from "./LinkAccion.vue?vue&type=script&lang=js&"
import style0 from "./LinkAccion.vue?vue&type=style&index=0&id=e8fd83c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fd83c0",
  null
  
)

export default component.exports